import { makeStyles } from '@material-ui/core/styles';

const useListStatusStyled = makeStyles((theme) => {
  return {
    container: {
      padding: '0.313rem 0 0',
    },
    label: {
      fontFamily: theme.typography.helveticaFont,
      fontSize: '0.625rem',
      color: theme.palette.general.grey100,
    },
    passsed: {
      color: theme.palette.statuses.dl_passed,
    },
    failed: {
      color: theme.palette.statuses.dl_failed,
    },
    notPerformed: {
      color: theme.palette.statuses.dl_not_performed,
    },
  };
});

export default useListStatusStyled;
